var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "doc-container" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "table-wrapper" }, [
          _c("table", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.column_data, function(item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(item[0]))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: item[1],
                          expression: "item[1]"
                        }
                      ],
                      ref: "woInputs",
                      refInFor: true,
                      staticStyle: { width: "100%" },
                      attrs: { type: "text" },
                      domProps: { value: item[1] },
                      on: {
                        focus: function($event) {
                          return _vm.selectRow(index)
                        },
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(item, 1, $event.target.value)
                          },
                          function($event) {
                            return _vm.filterResults(item[1])
                          }
                        ]
                      }
                    })
                  ])
                ])
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "textbox-wrapper" }, [
          _vm.activeIndex !== null
            ? _c(
                "div",
                {
                  staticClass: "textbox",
                  style: { "--pointer-top": _vm.pointerTop + "px" }
                },
                [
                  _c(
                    "table",
                    _vm._l(_vm.suggestions, function(suggestion) {
                      return _c(
                        "tr",
                        _vm._l(suggestion, function(item) {
                          return _c("td", [_vm._v(_vm._s(item))])
                        }),
                        0
                      )
                    }),
                    0
                  )
                ]
              )
            : _c("div", { staticClass: "emptybox" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-button" }, [
        _c("p", [
          _vm._v("Remaining Documents:"),
          _c("strong", [_vm._v(" " + _vm._s(_vm.remaining))])
        ]),
        _vm._v(" "),
        _c("button", { on: { click: _vm.submit } }, [_vm._v("Submit")])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right" },
      [
        _vm.activeIndex !== null
          ? _c("document", {
              attrs: {
                dir:
                  "doc_" +
                  parseInt(_vm.column_data[_vm.activeIndex][0]) +
                  ".jpg",
                doc_id: _vm.column_data[_vm.activeIndex][0].toString(),
                enforceMax: "105px"
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "100px" } }, [_vm._v("Doc ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("WO Number")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df99b21e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df99b21e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Assign_Document_WO.vue
// module id = 728
// module chunks = 0